export interface WindStage {
  stage: string;
  proA: number;
  proB: number;
  neutral: number;
  note: string;
}

export default function WindChart({ stages }: { stages: WindStage[] }) {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-[11px] text-foreground-600">
        <span className="flex items-center gap-2">
          <span className="h-2.5 w-2.5 rounded-sm bg-accent-500" aria-hidden="true" />
          指控方声量
        </span>
        <span className="flex items-center gap-2">
          <span className="h-2.5 w-2.5 rounded-sm bg-primary-700" aria-hidden="true" />
          被指方声量
        </span>
        <span className="flex items-center gap-2">
          <span className="h-2.5 w-2.5 rounded-sm bg-background-300" aria-hidden="true" />
          中立与观望
        </span>
      </div>

      <ul className="flex flex-col gap-5">
        {stages.map((stage) => (
          <li key={stage.stage}>
            <div className="flex flex-wrap items-baseline justify-between gap-2">
              <h3 className="font-heading text-sm font-semibold text-foreground-950">{stage.stage}</h3>
              <span className="font-heading text-xs font-semibold text-foreground-600">
                {stage.proA}% / {stage.proB}%
              </span>
            </div>
            <div className="mt-2 flex h-3 w-full overflow-hidden rounded-full bg-background-200">
              <div className="h-3 bg-accent-500" style={{ width: `${stage.proA}%` }} aria-hidden="true" />
              <div className="h-3 bg-background-300" style={{ width: `${stage.neutral}%` }} aria-hidden="true" />
              <div className="h-3 bg-primary-700" style={{ width: `${stage.proB}%` }} aria-hidden="true" />
            </div>
            <p className="mt-2 text-xs leading-relaxed text-foreground-600">{stage.note}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}